<template>

<div class="container-fluid">

  <div class="row">
    <div class="col-2">
      <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="100"/></span>
      <span v-else><img src="@/assets/images/logo.png" height="100"/></span>
    </div>
    <div class="col-7 mt-2">
      <h2 style="color:black;font-weight: 700; " class="text-uppercase mb-1">{{ userData.business }}</h2>
      <b style="color:black;font-size:12px">Location: {{ userData.location }}</b><br>
      <b style="color:black;font-size:12px">Contacts: {{ userData.contact }}</b><br>
      <b style="color:black;font-size:12px">E-mail: {{ userData.email }}</b><br>
      <b style="color:black;font-size:12px">Website: {{ userData.website }}</b> 
    </div>
    <div class="col-3 mt-3">
      <span style="color:black;font-size:13px;font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;"> Visit ID: <br> <b style="font-size: 20px;"> {{ this.visitid }}</b> <br> Date : {{ visit_date }}</span>
    </div>
  </div>
    <hr style="border: 1px solid black;">
            
    <center><span style="color: black;font-family: tahoma;font-size:13px" class="text-decoration-underline text-uppercase"><b> Radiology Report</b></span></center>
    <br><div v-for="item in patients" :key="item.id" class="d-flex justify-content-between">
  <span> Name: <b class=" h6">{{ item.name }} </b></span>
  <span> Patient ID: <b class=" h6">{{ item.patient_id }} </b></span>
  <span> Sex: <b class=" h6">{{ item.gender }} </b></span>
  <span> Age: <b class=" h6">{{ getAge(item.date_of_birth) }} yrs </b></span>
  <span> Telephone: <b class=" h6">0{{ item.telephone }} </b></span>
  </div>
<br><br>
        <span v-html="diagnosis"></span>
        {{ date }}
    <div class="mt-3 text-center">
        <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
        <p style="color:black;font-size:13px">Printed by : {{ userData.username }} <br>  Via Daherz Family Doctors | www.daherzfamilydoctors.com </p>
    
        <barcode :value="this.visitid" height="50" display-value="false"></barcode>
    
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import VueBarcode from 'vue-barcode';
  export default {
  components: { 'barcode': VueBarcode },
    data() {
      return {
        patients:[],
        patientspinner:true,
        userData: JSON.parse(localStorage.getItem("user")),
        patientid:'',
        visitid:'',
        service:'',
        service_id:'',
        recommedation:'',
        examination:'',
        history:'',
        service_category:[],
        service_name:[],
        service_price:'',
        patient_type:'1',
        date:'',
        diagnosis:'',
        treatmentresults:[],
        visit_date:"",
      };
    },
    created() {
      this.fetchInfo();
    },
    mounted() {
    setTimeout(() => {
        window.print();
        window.onafterprint=this.$router.go(-1);
    }, 5000);
    } ,
    methods: {
      getAge(dateString){
      let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth;
    },
     getFiles(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"logos/"+name;
        return imagelink;
      },
      async fetchInfo(){
        this.id=this.$route.query.id;
        let url = `/visitinfo/${this.id}`;
        await axios.get(url).then((response) => {
          this.patientid = response.data.visits[0].patient.patient_id;
          this.visitid = response.data.visits[0].visit_id;
          this.service = response.data.visits[0].service_name.name;
          this.service_id = response.data.visits[0].service_name.id;
          this.visit_date = response.data.visits[0].addedon;
          this.showpatient();
          this.showtreatments();
        });
      },
      async showpatient(){
        let url = `/patientprofile/${this.patientid}`;
        await axios.get(url).then((response) => {
          this.patients = response.data.patients;
          this.patientspinner=false;
        });
      },
      async showtreatments(){
        let url = `/profiletreatment/${this.patientid},${this.visitid},${this.service_id}`;
        await axios.get(url).then((response) => {
        if (response.data.treatments.length===0) {
          this.symptoms = '';
          this.history = '';
          this.examination = '';
          this.diagnosis = '';
          this.recommedation = '';
        }else{
          this.symptoms = response.data.treatments[0].symptoms;
          this.history = response.data.treatments[0].history;
          this.examination = response.data.treatments[0].examination;
          this.diagnosis = response.data.treatments[0].diagnosis;
          this.recommedation = response.data.treatments[0].recommedation;
          this.date = response.data.treatments[0].created_at;
        }
        });
      },
      
    },
  };
  </script>